import React from "react";

export default function UnauthorizedContent() {
	return (
		<div>
			<h3>Not Authorized.</h3>
		</div>
	);
}
